export enum DiskTypes  {
    Ssd = 'SSD Persistent Disk',
    Standard = 'Standard Persistent Disk',
    Balanced = 'Balanced Persistent Disk',
    Extreme = 'Extreme Persistent Disk'
  }
